
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Section } from '@/shared/types/aperTemplate';
import Roles from "@/shared/Roles";

@Component
export default class SectionDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Object, default: null }) readonly editingSection!: Section | null;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  valid = true;
  section: Section = this.getDefaultSection();

  roles = [
    { label: 'Supervisor', value: Roles.Supervisor },
    { label: 'Internal Examiner', value: Roles.InternalExaminer },
    { label: 'External Examiner', value: Roles.ExternalExaminer },
    { label: 'Reviewer', value: Roles.Reviewer },
    { label: 'HOD', value: Roles.Hod },
    { label: 'Registrar', value: Roles.Registrar },
    { label: 'VC', value: Roles.VC },
    { label: 'Super Admin', value: Roles.SuperAdmin }
  ];

  $refs!: {
    form: any;
  };

  get isEditing(): boolean {
    return !!this.editingSection;
  }

  get show(): boolean {
    return this.value;
  }

  set show(value: boolean) {
    this.$emit('input', value);
  }

  @Watch('editingSection')
  onEditingSectionChanged(newVal: Section | null) {
    if (newVal) {
      this.section = { ...newVal };
    } else {
      this.section = this.getDefaultSection();
    }
  }

  @Watch('value')
  onValueChanged(newVal: boolean) {
    if (newVal && this.editingSection) {
      this.section = { ...this.editingSection };
    } else if (newVal) {
      this.section = this.getDefaultSection();
    }
  }

  onVisibilityChange(visible: boolean) {
    if (!visible) {
      this.resetForm();
    }
  }

  getDefaultSection(): Section {
    return {
      name: '',
      description: '',
      displayOrder: 0,
      role: null,
      canEdit: true,
      includeInReportScore: false,
      fields: []
    };
  }

  close() {
    this.show = false;
  }

  resetForm() {
    this.$nextTick(() => {
      if (this.$refs.form) this.$refs.form.reset();
    });
  }

  save() {
    if (!this.$refs.form || !this.$refs.form.validate()) return;

    this.$emit('save', {
      ...this.section,
      displayOrder: Number(this.section.displayOrder)
    });
  }
}
